export const contact = {
  contactName: "Nombre",
  favoriteContact: "Favoritos",
  contactAction: "Acción",
  contactEmail: "Correo",
  contactTransfer: "Transferencia",
  contactDelete: "Eliminar ",
  contactDeleteMessage: "¿Esta seguro de eliminar este contacto?",
  contactEdit: "Editar",
  contactEditMessage: "¿Estás seguro que quiere modificar este contacto de su lista de favoritos?",
  contactConfirmYes: "Si",
  contactConfirmNo: "No",
  contactDeleteSuccess: "Contacto eliminado con éxito!",
  contactAddSuccess: "Contacto agregado con éxito!",
  contactBackBtn: "Volver",
  contactsBtnAdd: "Añadir",
  contactModalAdd: "Agregar Contacto",
  contactSearch: "Buscar Contacto",
  contactsTableUpdating: "Actualizando Contactos...",
  contactLoading: "Cargando información del contacto...",
  contactError: "Error al obtener información del contacto. El contacto no existe.",
  contactNotFound: "Contacto no encontrado.",
  contactAlreadyInList: "El contacto ya está en la lista.",
  contactAddBtn: "Añadir",
  contactCancelBtn: "Cancelar",
  contactBackBtnText: "Volver",
};
